import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => {
  return {
    searchBar: {
      backgroundColor: 'transparent',
      width: '25vh',
      marginRight: '1vh',
      '&.MuiFilledInput-root:hover': {
        backgroundColor: 'transparent',
      },
      '&.MuiInputBase-root :hover': {
        backgroundColor: 'transparent',
      },
      fontSize: 'larger',
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    aspectRatioContainer: {
      marginLeft: '-10px',
    },
  };
});

export default styles;
